const normalizeConversationBoundary = boundary => (
  boundary === 'start' ? 'start' : 'end'
)

const conversationBoundaryIsBottomAligned = boundary => (
  normalizeConversationBoundary(boundary) === 'end'
)

const conversationBoundaryWindowKey = ({
  taskId,
  boundary,
  revision
}) => [
  'conversation-window',
  taskId || 'none',
  normalizeConversationBoundary(boundary),
  Math.max(0, Number(revision) || 0)
].join(':')

module.exports = {
  conversationBoundaryIsBottomAligned,
  conversationBoundaryWindowKey,
  normalizeConversationBoundary
}
